export default {
  primary: '#005CE4',
  error: '#CE190D',
  errorAlt: '#bf160a',
  success: '#22AA00',
  successAlt: '#1f8719',
  warning: '#ff620c',
  warningAlt: '#E06F00',
  background: '#E4EBF1',
  backgroundAlt: '#DAE1E9',
  surface: '#FFFFFF',
  surfaceAlt: '#F0F4F8',
  secondary: '#C6D1DB',
  secondaryAlt: '#90A0B3',
  contrastHigh: '#000000',
  contrastLow: '#323a45',
  contrastInvert: '#ffffff',
  overlaySurface: 'rgba(0,0,0,0.8)', // deprecated, we should use overlayDark2 for 80% black
  overlayContrast: '#ffffff', // deprecated, we should use overlayLight for white
  overlayLight: '#ffffff',
  overlayLight2: 'rgba(255,255,255,0.8)',
  overlayLight3: 'rgba(255,255,255,0.5)',
  overlayDark: '#000000',
  overlayDark2: 'rgba(0,0,0,0.8)',
  overlayDark3: 'rgba(0,0,0,0.5)',
  code: {
    accent1: '#b4278b',
    accent2: '#22aa01',
    accent3: '#005ce5',
    accent4: '#323a44',
    accent5: '#7c4dff',
    accent6: '#ff5a01',
    accent7: '#01a272',
    accent8: '#38537e',
    accent9: '#ce190e',
  },
  brand: {
    cloudinaryBlue: '#3448c5',
    cloudinaryBlueLight: '#1d3c90',
    cloudinaryBlueDark: '#4c64d7',
    offsetGray: '#f1f2f9',
    darkBlue: '#0c163b',
    accentCoral: '#ff5050',
    accentPeach: '#ffd4c4',
    accentYellow: '#f7bc00',
    accentTurquoise: '#48c4d8',
    accentLightBlue: '#b6d2ff',
  },
  dataVis: {
    accent1: '#3448c5',
    accent2: '#48d0d8',
    accent3: '#ff5050',
    accent4: '#924dff',
    accent5: '#fc41cb',
    accent6: '#ce190f',
    accent7: '#ffb14e',
    accent8: '#22aa03',
    accent9: '#90a0b2',
    accent10: '#323a42',
  },
};
